import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { getMockVar } from '@/utils/mock';

dayjs.extend(isBetween);

const SpringStartTime = dayjs('2024/02/01 00:00:00');
const SpringEndTime = dayjs('2024/02/29 23:59:59');

/**
 * 是否是在活动周期内
 */
export function checkIsInSpring() {
  // mock时间
  const isMock = +getMockVar('isMockSpring') === 1;
  const curTime = dayjs(getServerTime());
  return curTime.isBetween(SpringStartTime, SpringEndTime) || isMock;
}
